<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HmctaY/tc-custom/9780253023353.jpg?1702083809364" alt="This image is the cover for the book American Tune, Break Away Book Club Edition"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">American Tune, Break Away Book Club Edition
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A woman’s former life as a radical antiwar protestor threatens her new identity as a wife and mother in this “poignant and stirring novel” (<i>Booklist</i>).</b></p><p>While reluctantly accompanying her husband and daughter to freshman orientation at Indiana University, Nora Quillen hears someone call her name—her <i>real</i> name—a name she has not heard in more than twentyfive years. Not even her husband knows that back in the ‘60s she was Jane Barth, a student deeply involved in the antiwar movement. Now Jane, and her radical past, are about to come into the light.</p> Shuttling between the present day and the turbulent 1960s, <i>An American Tune</i> tells the story of Jane, a girl from a working-class family who flees when she becomes complicit in a deadly bombing, and Nora, the woman she becomes: a wife and mother living a quiet life in northern Michigan. <i>An American Tune</i> is both a poignant story of a family crushed under the weight of suppressed truths, and an evocation of a country struggling with its own violent legacy.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barbara Shoup
      </h2>
      
      <p class="authorDescription body article">Barbara Shoup is author of six novels and co-author of two books about the creative process. Her short fiction, poetry, essays, and interviews have appeared in The Writer and the New York Times travel section and her young adult novels, Wish You Were Here and Stranded in Harmony, were selected as American Library Association Best Books for Young Adults.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?17acfb66